























































































import { Vue, Component, Prop } from 'nuxt-property-decorator';
import CryptoJS from 'crypto-js';
import { BlokFormContact, FieldsContactForm } from '../../types';
import ButtonWrapper from '@/components/utilities/buttons/ButtonWrapper';

@Component({
  components: { ButtonWrapper }
})
export default class FormContact extends Vue {
  @Prop() blok!: BlokFormContact;
  $refs!: { select: HTMLElement, selectDate: HTMLElement, selectInput: HTMLInputElement, selectInputDate: HTMLInputElement };
  form: FieldsContactForm = {
    company: '',
    email: '',
    salutation: '',
    firstname: '',
    lastname: '',
    message: ''
  };
  selectSalutationVisible: boolean = false;
  selectDateVisible: boolean = false;
  salutationOptions: string[] = ['Frau', 'Herr', 'Divers'];
  error: string = '';
  success: string = '';
  interestName: string = '';
  selectedDate: string = '';
  allInterests: string[];
  emailExists: boolean = false;
  interestIsNew:boolean = false;
  subscriptionStatus: string = 'unsubscribed';
  interestID: string = '';

  async sendMail (): Promise<void> {
    if (!this.blok.show_date) {
      await this.sendEmail();
    } else if (!this.formValid) {
      this.error = 'ℹ️   Füllen Sie bitte alle Formularfelder aus.';
    } else {
      this.error = '';
      // get all interests
      await this.getAllInterests(this.interestName);
    }
  }
  /* ===
  * Form Validation
  * == */
  get formValid (): boolean {
    if (!this.form.firstname) { return false; }
    if (!this.form.lastname) { return false; }
    // if (!this.form.message || this.form.message.length <= 10) { return false; }
    if (!this.form.email) {
      return false;
    } else {
      const regexMail: RegExp = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!regexMail.test(this.form.email)) { return false; }
    }
    return true;
  }

  /* ===
  * Get All Interest
  * == */
  async getAllInterests (interestname) {
    await this.$axios.get(`${process.env.NUXT_APP_BASE_URL}.netlify/functions/get-all-interests`, {})
      .then(async (res: any) => {
        const interests = JSON.parse(res.data.data);
        this.allInterests = interests.interests.map((item) => {
          return {
            name: item.name,
            id: item.id
          };
        });
        /* ===
        * Check If Interest Exists
        * == */
        if (!this.allInterests.some(obj => obj.name === interestname)) {
          // add new interest
          this.interestIsNew = true;
          await this.addNewInterest(interestname);
        } else {
          this.interestIsNew = false;
          this.interestID = this.allInterests.find(obj => obj.name === interestname).id;
        }
        // get user information
        await this.getUser();
        await this.updateUser();
      })
      .catch(() => {
        this.error = 'Es ist ein interner Fehler aufgetreten, versuchen Sie es später erneut.';
      });
  }
  /* ===
  * Create New Interst
  * == */
  async addNewInterest (interestname) {
    await this.$axios.post(`${process.env.NUXT_APP_BASE_URL}.netlify/functions/event-registration`, {
      interestName: interestname
    })
      .then((res: any) => {
        this.error = '';
        this.interestID = res.data.data.id;
      })
      .catch(() => {
        this.error = 'Es ist ein interner Fehler aufgetreten, versuchen Sie es später erneut.';
      });
  }
  /* ===
  * Get User Hash
  * == */
  getUserHash () {
    return CryptoJS.MD5(this.form.email.toLowerCase()).toString();
  }

  /* ===
  * Get User Information
  * == */
  async getUser () {
    await this.$axios.post(`${process.env.NUXT_APP_BASE_URL}.netlify/functions/get-user-info`, {
      userMailHash: this.getUserHash()
    })
      // eslint-disable-next-line require-await
      .then(async (res: any) => {
        const userData = JSON.parse(res.data.data);
        // this.alreadyExistingInterestIDs = Object.keys(userData.interests).filter(key => userData.interests[key] === true);
        this.subscriptionStatus = userData.status;
        this.emailExists = true;
      })
      .catch(() => {
        this.emailExists = false;
      });
  }

  /* ===
  * Update User
  * == */
  async updateUser () {
    await this.$axios.post(`${process.env.NUXT_APP_BASE_URL}.netlify/functions/update-user`, {
      userMailHash: this.getUserHash(),
      email: this.form.email,
      firstname: this.form.firstname,
      lastname: this.form.lastname,
      salutation: this.form.salutation,
      company: this.form.company,
      newsbetter: this.subscriptionStatus,
      newsbetterIfNew: 'unsubscribed',
      interestID: this.interestID
    })
      .then(() => {
        this.error = '';
        this.handleSuccess();
      })
      .catch(() => {
        this.error = 'Es ist ein interner Fehler aufgetreten, versuchen Sie es später erneut.';
      });
  }
  handleSuccess () {
    this.sendEmail();
    this.form = {
      company: '',
      email: '',
      salutation: '',
      firstname: '',
      lastname: '',
      message: ''
    };
  }
  async sendEmail () {
    if (!this.formValid) {
      this.error = 'ℹ️   Füllen Sie bitte alle Formularfelder aus.';
    } else {
      this.form.message = `Anmeldung für "${this.interestName}" - ${this.form.message}`;
      this.error = '';
      await this.$axios.post(`${process.env.NUXT_APP_BASE_URL}.netlify/functions/send-contact-form`, {
        subject: 'echt.ch - Kontaktaufnahme Formular',
        form: this.form
      })
        .then((res: any) => {
          this.success = '👍📨  Ihre Kontaktanfrage wurde erfolgreich gesendet. Wir melden uns bei Ihnen.';
        })
        .catch((e: any) => {
          this.error = '👎📭   Ihre Kontaktanfrage konnte nicht gesendet werden.';
        });
    }
  }
  showSelectList (): void {
    this.selectSalutationVisible = !this.selectSalutationVisible;
  }
  showSelectListDate (): void {
    this.selectDateVisible = !this.selectDateVisible;
  }
  setOption (option: string): void {
    this.form.salutation = option;
    this.showSelectList();
  }
  setOptionDate (datum, option): void {
    this.interestName = option;
    this.selectedDate = datum;
    this.showSelectListDate();
  }
  mounted () {
    if (this.blok.dates && this.blok.dates.length === 1) {
      this.selectedDate = this.blok.dates[0].datum;
    }
    if (process.browser) {
      this.$refs.select.style.width = `${this.$refs.selectInput.offsetWidth}px`;
      this.$refs.select.style.top = `${this.$refs.selectInput.offsetHeight}px`;
      if (!this.success && this.blok.show_date && this.selectDateVisible) {
        this.$refs.selectDate.style.width = `${this.$refs.selectInputDate.offsetWidth}px`;
        this.$refs.selectDate.style.top = `${this.$refs.selectInputDate.offsetHeight}px`;
      }
    }
  }
}
